import $ from 'jquery'
import Swiper from 'swiper/js/swiper.js'
import ImagesLoaded from 'Imagesloaded'

export default {
  init() {
    const slideshow = new Swiper('.slideshow-swiper-container', {
      init: false,
      pagination: {
        el: '.slideshow-pagination',
        clickable: true,
      },
      loop: true,
      autoplay: {
        delay: 6000,
      },
      speed: 400,
      effect: 'fade',
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        992: {
          speed: 800,
        }
      }
    });

    ImagesLoaded( '.slideshow-swiper-container', ()=> {
      slideshow.init()
    })
    
    slideshow.on('init', ()=> {
      setTimeout(() => {
        $('.slideshow').removeClass('is-loading')
      }, 300);
    })
    
    $(document).on('click', '.slideshow-navigation .next', function(event) {
      event.preventDefault();
      slideshow.slideNext(400, true);
    });

    $(document).on('click', '.slideshow-navigation .prev', function(event) {
      event.preventDefault();
      slideshow.slidePrev(400, true);
    });

    const news = new Swiper('.news-swiper-container', {
      init: false,
      navigation: {
        nextEl: '.news-nav-next',
        prevEl: '.news-nav-prev',
      },
      loop: false,
      autoplay: {
        delay: 5000,
      },
      speed: 200,
      // autoHeight: true,
      grabCursor: true,
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 0,
      breakpoints: {
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          speed: 800,
        }
      }

    });

    ImagesLoaded( '.news-swiper-container', ()=> {
      news.init()
    })
    
    var other = new Swiper('.jwd-slide', {
      init: false,
      pagination: {
        el: '.jwd-slide-pagination',
        clickable: true,
      },
      loop: true,
      autoplay: {
        delay: 4000,
      },
      speed: 400,
      effect: 'fade',
      grabCursor: true,
      // autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 0,
    })

    const product = new Swiper('.product-swiper-container', {
      init: false,
      navigation: {
        nextEl: '.product-nav-next',
        prevEl: '.product-nav-prev',
      },
      loop: false,
      autoplay: {
        delay: 4000,
      },
      speed: 200,
      grabCursor: true,
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 16,
      breakpoints: {
        768: {
          spaceBetween: 30,
        },

        1440: {
          spaceBetween: 60,
          slidesPerView: 3,
          slidesPerGroup: 3,
          speed: 800
        },

        1640: {
          spaceBetween: 110,
          slidesPerView: 3,
          slidesPerGroup: 3,
          speed: 800
        }
      }
    })

    ImagesLoaded( '.product-swiper-container', ()=> {
      product.init()
    })

    if($('.jwd-slide').length) {
      ImagesLoaded( '.jwd-slide', ()=> {
        other.init()
      })
    }

    $(document).on('click', '.independent .button-show-more', function(event) {
      event.preventDefault();
      $('.independent-content-more').toggleClass('show');
      $(this).toggleClass('show');
    });    
    
    $('.video').magnificPopup({
      mainClass: 'vtour-popup',
      type: 'iframe'
    });

  },
  finalize() {
  },
}
